export default {
  Title   : 'Rate our App!',
  Subtitle: 'If you enjoy using Marketplace, please take a moment to rate your experience with our application. It really helps!',
  Button  : 'Rate Now',
  Comments: 'Rating Comment',
  Reviews : 'Reviews',
  Success : 'Thanks for taking a moment to rate our app!'
}
